<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    viewBox="0 0 14 14"
  >
    <defs>
      <clipPath id="selected-box">
        <rect x="0" y="0" width="14" height="14" rx="0" />
      </clipPath>
    </defs>
    <g>
      <g>
        <path
          id="selected"
          d="M7,14C10.866,14,14,10.866,14,7C14,3.13401,10.866,0,7,0C3.13401,0,0,3.13401,0,7C0,10.866,3.13401,14,7,14ZM10.6541,5.94576C10.7798,5.81531,10.85,5.6412,10.85,5.46003C10.85,5.07344,10.5366,4.76003,10.15,4.76003C9.95985,4.76003,9.77789,4.83739,9.64595,4.97431L6.68171,8.0504Q6.57945,8.15652,6.43209,8.15753Q6.28472,8.15854,6.18102,8.05384L4.69734,6.5559C4.56587,6.42317,4.38681,6.3485,4.2,6.3485C3.8134,6.3485,3.5,6.6619,3.5,7.0485C3.5,7.23299,3.57283,7.41002,3.7029,7.54134L5.18634,9.03904Q5.70487,9.56256,6.4417,9.5575Q7.17853,9.55244,7.68982,9.02185L10.6541,5.94576Z"
          fill-rule="evenodd"
          :fill="fill"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
  <script>
export default {
  name: "SelectedSvg",
  props: {
    color: {
      type: String,
      default: "",
    },
    fill: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {};
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$el.querySelector("#selected-box").setAttribute("fill", this.color);
    },
  },
};
</script>
<style scoped lang="less">
svg {
    width: 16px;
    height: 16px;
  .adapt_pc_widescreen & {
    width: 20px;
    height: 20px;
  }
}
</style>
  